import React from 'react';
import { colors, fonts, fontSize } from '../tokens';

/**
 * SectionHeader – einheitliches Eyebrow + Headline + OrangeRule Triple
 * für alle Sektionen.
 */
export const SectionHeader = ({ eyebrow, headline, marginBottom = 0 }) => (
  <div style={{ marginBottom }}>
    <span
      className="section-overline"
      style={{
        fontFamily: fonts.body,
        fontSize: fontSize.eyebrow,
        fontWeight: 700,
        letterSpacing: '0.14em',
        textTransform: 'uppercase',
        color: colors.orange,
        marginBottom: '6px',
        display: 'block',
      }}
    >
      {eyebrow}
    </span>
    <h2
      className="proposal-h2"
      style={{
        fontFamily: fonts.display,
        fontSize: fontSize.h2,
        fontWeight: 700,
        color: colors.navy,
        marginBottom: 0,
      }}
    >
      {headline}
    </h2>
    <div
      className="orange-rule"
      style={{
        height: '2px',
        width: '48px',
        background: colors.orange,
        borderRadius: '2px',
        marginTop: '8px',
        marginBottom: 0,
      }}
    />
  </div>
);
